import { DEFAULT_HEATMAP } from '../theme';

export function hexToRgb(hex) {
  const h = (hex || '#ff0000').startsWith('#') ? hex.slice(1) : hex;
  return {
    r: parseInt(h.slice(0, 2), 16) || 255,
    g: parseInt(h.slice(2, 4), 16) || 0,
    b: parseInt(h.slice(4, 6), 16) || 0,
  };
}

/** Interpola t (0..1) entre colorLow y colorHigh. */
export function valueToHeatColor(t, heatmapConfig) {
  const clamp = Math.max(0, Math.min(1, t));
  const cfg = heatmapConfig || DEFAULT_HEATMAP;
  const low = hexToRgb(cfg.colorLow || DEFAULT_HEATMAP.colorLow);
  const high = hexToRgb(cfg.colorHigh || DEFAULT_HEATMAP.colorHigh);
  const alpha = cfg.colorOpacity != null ? cfg.colorOpacity : DEFAULT_HEATMAP.colorOpacity;
  const r = Math.round(low.r + (high.r - low.r) * clamp);
  const g = Math.round(low.g + (high.g - low.g) * clamp);
  const b = Math.round(low.b + (high.b - low.b) * clamp);
  return `rgba(${r},${g},${b},${alpha})`;
}

/** Paleta 256×RGBA para colorear intensidad (estilo simpleheat). */
export function buildHeatPalette(colorLow, colorHigh, maxAlpha = 255) {
  const palette = new Uint8ClampedArray(256 * 4);
  const low = hexToRgb(colorLow);
  const high = hexToRgb(colorHigh);
  for (let i = 0; i < 256; i += 1) {
    const t = i / 255;
    palette[i * 4] = Math.round(low.r + (high.r - low.r) * t);
    palette[i * 4 + 1] = Math.round(low.g + (high.g - low.g) * t);
    palette[i * 4 + 2] = Math.round(low.b + (high.b - low.b) * t);
    palette[i * 4 + 3] = Math.round((i / 255) * maxAlpha);
  }
  return palette;
}

export function colorizeIntensityImage(intensityCtx, width, height, palette, colorOpacity = 0.85) {
  const img = intensityCtx.getImageData(0, 0, width, height);
  const data = img.data;
  for (let i = 0; i < data.length; i += 4) {
    const alpha = data[i + 3];
    if (!alpha) continue;
    const pi = alpha * 4;
    data[i] = palette[pi];
    data[i + 1] = palette[pi + 1];
    data[i + 2] = palette[pi + 2];
    data[i + 3] = Math.round(palette[pi + 3] * colorOpacity);
  }
  intensityCtx.putImageData(img, 0, 0);
}
